import { render, staticRenderFns } from "./NoDetails.vue?vue&type=template&id=6ec12ed0&scoped=true&"
import script from "./NoDetails.vue?vue&type=script&lang=js&"
export * from "./NoDetails.vue?vue&type=script&lang=js&"
import style0 from "./NoDetails.vue?vue&type=style&index=0&id=6ec12ed0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec12ed0",
  null
  
)

export default component.exports